import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export const Footer: React.FC = () => (
  <footer className="bg-gray-900 text-white py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt="SimpleTracker Logo"
              className="w-8 h-8 rounded-md"
            />
            <h3 className="text-xl font-bold text-white">SimpleTracker</h3>
          </div>
          <p className="text-gray-300 mb-4">
            The simplest way to track your net worth and make smarter financial decisions.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-4 text-white">Product</h4>
          <ul className="space-y-2 text-gray-300">
            <li><HashLink smooth to="/#pricing" className="hover:text-brand-400 transition-colors">Pricing</HashLink></li>
            <li><HashLink smooth to="/#features" className="hover:text-brand-400 transition-colors">Features</HashLink></li>
            <li><Link to="/api" className="hover:text-brand-400 transition-colors">API</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4 text-white">Support</h4>
          <ul className="space-y-2 text-gray-300">
            <li><Link to="/help-center" className="hover:text-brand-400 transition-colors">Help Center</Link></li>
            <li><Link to="/contact" className="hover:text-brand-400 transition-colors">Contact Us</Link></li>
            <li><Link to="/status" className="hover:text-brand-400 transition-colors">Status</Link></li>
            <li><Link to="/community" className="hover:text-brand-400 transition-colors">Community</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4 text-white">Legal</h4>
          <ul className="space-y-2 text-gray-300">
            <li><Link to="/privacy" className="hover:text-brand-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-brand-400 transition-colors">Terms of Service</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-brand-400 transition-colors">Cookie Policy</Link></li>
            <li><Link to="/gdpr" className="hover:text-brand-400 transition-colors">GDPR</Link></li>
            <li><Link to="/careers" className="hover:text-brand-400 transition-colors">Careers</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-300">
        <p>&copy; {new Date().getFullYear()} SimpleTracker. All rights reserved.</p>
      </div>
    </div>
  </footer>
); 